export const INDENTS = {
  INDENT_0: '--indents-0',
  INDENT_5: '--indents-5',
  INDENT_10: '--indents-10',
  INDENT_15: '--indents-15',
  INDENT_20: '--indents-20',
  INDENT_25: '--indents-25',
  INDENT_30: '--indents-30',
  INDENT_35: '--indents-35',
  INDENT_40: '--indents-40',
  INDENT_50: '--indents-50',
  INDENT_55: '--indents-55',
  INDENT_60: '--indents-60',
  INDENT_70: '--indents-70',
  INDENT_80: '--indents-80',
  INDENT_90: '--indents-90',
  INDENT_100: '--indents-100',
  INDENT_110: '--indents-110',
  INDENT_120: '--indents-120',
  INDENT_130: '--indents-130',
  INDENT_140: '--indents-140',
  INDENT_150: '--indents-150',
  INDENT_160: '--indents-160',
  INDENT_170: '--indents-170',
  INDENT_180: '--indents-180',
} as const
export type INDENTS = (typeof INDENTS)[keyof typeof INDENTS]
